<template>
    <section class="m--wrapper c--wrapper space-betw">
        <section class="m--space--f">
            <router-link class="top--text" to="/">
                <i class="fas fa-chevron-left"/>
                <span>terug</span>
            </router-link>
            <h1 class="title-r--h1">
                Om te beginnen moet je eerst een datum prikken.
            </h1>
        </section>
        <section>
            <div class="grey bgc--p--button a--button h--flex--center c--flex--center">
                <span class="smh">{{ getSelectedDate() }}</span>
            </div>
        </section>
        <section class="select--date">
            <div class="date">
                <label for="day">Dag</label>
                <select :value="$store.state.selectDateStep.day.selectedDay" @change="selectDayDate($event)" id="day"
                        name="day">
                    <option :key="dayIndex"
                            :selected="checkSelectedDate(day, $store.state.selectDateStep.day.currentDay)"
                            :value="day"
                            v-for="(day, dayIndex) in $store.state.selectDateStep.month.amountMonthDays">
                        {{ day }}
                    </option>
                </select>
            </div>
            <div class="date">
                <label for="month">Maand</label>
                <select :value="$store.state.selectDateStep.month.selectedMonth" @change="selectMonthDate($event)"
                        id="month"
                        name="month">
                    <option :key="monthIndex"
                            :selected="checkSelectedDate(month, $store.state.selectDateStep.month.currentMonth)"
                            :value="month"
                            v-for="(month, monthIndex) in $store.state.selectDateStep.month.amountMonths">
                        {{ month }}
                    </option>
                </select>
            </div>
            <div class="date">
                <label for="year">Jaar</label>
                <select :value="$store.state.selectDateStep.year.selectedYear" @change="selectYearDate($event)"
                        id="year"
                        name="year">
                    <option :key="yearIndex"
                            :selected="checkSelectedDate(year, $store.state.selectDateStep.year.currentYear)"
                            :value="year"
                            v-for="(year, yearIndex) in $store.state.selectDateStep.year.amountYears">
                        {{ year }}
                    </option>
                </select>
            </div>
            <section class="select--service-periode">
                <label>Dagdeel</label>
                <div class="periode--wrap">
                    <div :class="{ enabled: controlDayPart('ochtend') }" @click="selectPart('ochtend')"
                         class="select--periode-button morning">Ochtend
                    </div>
                    <div :class="{ enabled: controlDayPart('avond') }" @click="selectPart('avond')"
                         class="select--periode-button evening">Avond
                    </div>
                    <div class="no--periode">
                        <div :class="{ enabled: controlDayPart('') }" @click="selectPart('')"
                             class="select--periode-button">Geen dagdeel
                        </div>
                    </div>
                </div>
            </section>
            <router-link :class="{ disabled: !controlFields(), enabled: controlFields() }" class="next--button"
                         to="/select-song">
                Doorgaan <i class="fas fa-long-arrow-alt-right fa-2x"/>
            </router-link>
        </section>
    </section>
</template>

<script>
export default {
  name: 'selectDate',
  mounted () {
    const dateObj = new Date()

    this.$store.commit('setDefaultDates', {
      currentStateDay: dateObj.getUTCDate(),
      currentStateMonth: dateObj.getUTCMonth() + 1,
      currentStateYear: dateObj.getUTCFullYear()
    })

    for (let i = 0; i < this.$store.state.calculateCurrentDays(this.$store.state.selectDateStep.month.currentMonth, this.$store.state.selectDateStep.year.currentYear); i++) {
      this.$store.state.selectDateStep.month.amountMonthDays = i + 1
    }

    this.$store.state.calculateYears(this.$store.state.selectDateStep.year.currentYear)
    this.getSelectedDate()
  },
  methods: {
    getDayName (dateStr, locale) {
      let date = new Date(dateStr)
      return date.toLocaleDateString(locale, { weekday: 'long' })
    },
    getMonthName (dateStr, locale) {
      let date = new Date(dateStr)
      return date.toLocaleDateString(locale, { month: 'long' })
    },
    getSelectedDate () {
      let serviceDateName = this.$store.state.selectDateStep.month.selectedMonth + '/' + this.$store.state.selectDateStep.day.selectedDay + '/' + this.$store.state.selectDateStep.year.selectedYear

      let dayName = this.getDayName(serviceDateName, 'nl-NL')
      let monthName = this.getMonthName(serviceDateName, 'nl-NL')
      let dayPart = this.$store.state.service.serviceDate.dayPart + ' '

      return dayName + ' ' + dayPart + this.$store.state.selectDateStep.day.selectedDay + ' ' + monthName
    },
    controlDayPart (dayPiece) {
      return this.$store.state.service.serviceDate.dayPart === dayPiece
    },
    controlFields () {
      this.$store.state.selectDateStep.dateReady = this.$store.state.selectDateStep.day.selectedDay !== null && this.$store.state.selectDateStep.month.selectedMonth !== null && this.$store.state.selectDateStep.year.selectedYear !== null && this.$store.state.service.serviceDate.dayPart !== null
      return this.$store.state.service.serviceDate.dayPart !== null
    },
    selectPart (dayPart) {
      if (this.$store.state.service.serviceDate.dayPart !== dayPart) {
        this.$store.commit('selectDayPart', {
          selectedPart: dayPart
        })
      }
    },
    checkSelectedDate (currentDate, currentStateDate) {
      return currentDate === currentStateDate
    },
    selectDayDate (event) {
      this.$store.commit('selectDay', {
        selectedDate: event.target.value
      })
    },
    selectMonthDate (event) {
      this.$store.commit('selectMonth', {
        selectedDate: event.target.value
      })
    },
    selectYearDate (event) {
      this.$store.commit('selectYear', {
        selectedDate: event.target.value
      })
    }
  }
}
</script>
